import React from "react";
import { Helmet } from "react-helmet";
import Header from "../../../components/default/header";
import GlobalSidebarMenu from "../../default/header/globalSidebarMenu";
import CreateCardForm from "./createCardForm";
import Breadcrumb from "../../default/breadcrumb/breadcrumb";

const CreateCard = () => {
    return (
        <div className="menu-with-settings sidebar-menu-enable">
        <Helmet><title>Create Card</title></Helmet>
        <Header />
        <div className="sidebar-with-content ds-flex">
            <GlobalSidebarMenu Pagetitle="" />
            <div className="content-right">
                <Breadcrumb />
                <CreateCardForm />
            </div>
        </div>
    </div>
    
    );
}

export default CreateCard;